const VARIANTS = {
  success: 'bg-emerald-400/10 border border-emerald-400/20 text-emerald-400',
  warning: 'bg-amber-400/10 border border-amber-400/20 text-amber-400',
  danger: 'bg-red-400/10 border border-red-400/20 text-red-400',
  neutral: 'bg-bg-elevated border border-border text-text-muted',
};

export default function Badge({ children, variant = 'neutral' }) {
  return (
    <span className={`inline-flex items-center gap-1 text-xs px-2 py-0.5 rounded-full ${VARIANTS[variant] ?? VARIANTS.neutral}`}>
      {children}
    </span>
  );
}
